export default __webpack_public_path__ + "static/media/cupomDescontoExpressoDiamanteTransbrasilPassagensAdamantina.b4ddb7df.webp";